export default {
  parishesCount: state => Object.keys(state.parishes).length,
  parishes: state => state.parishes,
  currentParish: state => state.current,
  donationTypes: state => state.donationTypes,
  donations: state => state.donations,
  allDonations: state => state.allDonations
}
